window.phoneLinkClicksTracking = function phoneLinkClicksTracking() {
    if ($('a[href^="tel:"]').length) {
        $('a[href^="tel:"]').addClass('js_PhoneClicked');
    }
}

$(document).ready(function () {
    'use strict';

    phoneLinkClicksTracking();
});